import React from 'react';

import DailyConversations from 'component/molecules/Dashboard/daily-conversations/DailyConversations';
import MessagesByTopic from 'component/molecules/Dashboard/messages-by-topic/MessagesByTopic';
import UserActivities from 'component/molecules/Dashboard/user-activities/UserActivities';
import UserInsightsStatistics from 'component/molecules/Dashboard/user-insights-statistics/UserInsightsStatistics';
import RemainingTokens from 'component/organism/analytics/bot-performance/remaining-tokens/RemainingTokens';
import ResolutionRate from 'component/organism/analytics/bot-performance/resolution-rate/ResolutionRate';
import UserSatisfactionRate from 'component/organism/analytics/bot-performance/user-satisfaction-rate/UserSatisfactionRate';
import MostUsedWorkflow from 'component/organism/analytics/bot-performance/most-used-workflow/MostUsedWorkflow';
import MostUsedKnowledgeBase from 'component/organism/analytics/bot-performance/most-used-knowledge-base/MostUsedKnowledgeBase';
import { EXPORT_PX_WIDTH } from '../capturePdf';

const AnalyticsPdf = ({
  page1Ref,
  page2Ref,
  page3Ref,
  page4Ref,
  id,
  startDate,
  endDate,
  days,
  brandingData,
  setLoader,
  styles,
  botType,
}) => {
  return (
    <div
      style={{
        width: EXPORT_PX_WIDTH,
        maxWidth: EXPORT_PX_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
      }}
    >
      <div ref={page1Ref} data-export-page className={styles['pdf-page-2']}>
        <DailyConversations
          brandingData={brandingData}
          botId={id}
          startDate={startDate}
          endDate={endDate}
          days={days}
          snapshotMode={true}
          botType={botType}
        />

        <MessagesByTopic
          brandingData={brandingData}
          id={id}
          startDate={startDate}
          endDate={endDate}
          snapshotMode={true}
          botType={botType}
        />
      </div>
      <div ref={page2Ref} data-export-page className={styles['pdf-page-2']}>
        <UserActivities
          brandingData={brandingData}
          id={id}
          startDate={startDate}
          endDate={endDate}
          snapshotMode={true}
          botType={botType}
        />

        <UserInsightsStatistics
          startDate={startDate}
          endDate={endDate}
          botId={id}
          snapshotMode={true}
          botType={botType}
        />
      </div>

      <div ref={page3Ref} data-export-page className={styles['pdf-page-3']}>
        <div className={styles['pdf-page-2']}>
          <div className={styles['pdf-rates']}>
            <RemainingTokens botId={id} snapshotMode={true} />

            <ResolutionRate
              botId={id}
              startDate={startDate}
              endDate={endDate}
              snapshotMode={true}
              botType={botType}
            />

            <UserSatisfactionRate
              botId={id}
              startDate={startDate}
              endDate={endDate}
              snapshotMode={true}
              botType={botType}
            />
          </div>

          <MostUsedWorkflow
            id={id}
            startDate={startDate}
            endDate={endDate}
            snapshotMode={true}
            botType={botType}
          />
        </div>
      </div>
      <div data-export-page ref={page4Ref}>
        <MostUsedKnowledgeBase
          id={id}
          startDate={startDate}
          endDate={endDate}
          skipFetch={true}
          snapshotMode={true}
          setLoader={setLoader}
          botType={botType}
        />
      </div>
    </div>
  );
};

export default AnalyticsPdf;
